import { render, staticRenderFns } from "./SponsoredRecommendationPremiumVideo.vue?vue&type=template&id=302de6f9&scoped=true"
import script from "./SponsoredRecommendationPremiumVideo.vue?vue&type=script&setup=true&lang=ts"
export * from "./SponsoredRecommendationPremiumVideo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SponsoredRecommendationPremiumVideo.vue?vue&type=style&index=0&id=302de6f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302de6f9",
  null
  
)

export default component.exports